<template>
    <div>
        <button
            type="button"
            @click="handleClick"
            @keyup.enter.prevent="handleEnter"
            :class="classes"
            :disabled="loading || disabled"
            :id="buttonId"
        >
            {{ label }}
            <span class="inline ml-2" v-if="loading">
                <i class="fas fa-spinner-third fa-spin"></i>
            </span>
        </button>
    </div>
</template>

<script>
export default {
    props: {
        label: String,
        loading: Boolean,
        classes: String,
        buttonId: String,
        useEnter: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({}),
    methods: {
        handleEnter(e) {
            if (this.useEnter) {
                this.$emit('clicked');
            }
        },
        handleClick() {
            this.$emit('clicked');
        },
    },
};
</script>
